<ion-content class="container">
  <div class="tabs-container">
    <div class="mt-10 d-flex pt-5 pb-10 pr-10 pl-0 headerBreadcrumb">
      <img (click)="onClickBreadcrumExpence()" src="././assets/icon/backArrow.svg" class="cp">
      <label class="font_semibold fs-18 ml-10 mt-5 black_color">
        <span class="cp" (click)="onClickBreadcrumExpence()">Expense</span> /
        <span [style.color]="buttonColorName">Logs</span>
      </label>
    </div>
    <div class="card">
      <ion-row *ngIf="!router.url.includes('Setup')">
        <ion-col size-sm="10" size-md="7" size-lg="7" size-xs="10" class="pl-15 pr-0 pb-0">
          <div class="borderbottomForTab" *ngIf="!router.url.includes('Setup')">
            <mat-tab-group #tabGroup class="pt-10 pr-10" [selectedIndex]="selectedTypeTabIndex"
              (selectedTabChange)="tabTypeChanged($event)">
              <mat-tab label="Deleted Reimbursement">
                <ng-template mat-tab-label>
                  <span style="display: contents;">
                    <span class="material-icons mr-10">
                      delete
                    </span>Deleted Reimbursement</span>
                </ng-template>
              </mat-tab>
              <mat-tab label="Updated Reimbursement">
                <ng-template mat-tab-label>
                  <span style="display: contents;">
                    <span class="material-icons mr-10">
                      update
                    </span>Updated Reimbursement</span>
                </ng-template>
              </mat-tab>
            </mat-tab-group>
          </div>
        </ion-col>
      
      </ion-row>
    </div>
    
    <div class="card  employeeTab">
      <ion-row>
        <ion-col size="4" class="mt-10">
          <div class="formLabelRegularfs16 mb-5">
            Year
          </div>
          <mat-form-field class="w-100 mat-height40 mat-input-style">
            <mat-select placeholder="Select" [(ngModel)]="selectedYearForCompetency"
              (selectionChange)="viewReimbursementByYear($event.value)">
              <mat-option [value]="item.year" *ngFor="let item of pmsYears">
                {{sharedService.transformYearToFyFormat(item.year)}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </ion-col>
      
      </ion-row>
      <div class="p-10 m-20" *ngIf="selectedTypeTabName=='Updated Reimbursement'">
      
        <div class="table-container">
    
          <table class="custom-table rounded-header">
    
            <thead>
              <tr>
                
                <th *ngFor="let item of taskColumnHeaderInfo " class="fs-14 font_bold cl-black">
                  <div class="p-5 verticle-center justify-content-space-between icon-style">
                    {{ item?.label }}
                    <span *ngIf="item.isMandatory" class="red-cl">&nbsp;*</span>
                    <div class="d-flex flex-column ml-10">
                      <i (click)="onSortAssending(item.sortingName)"
                        class="material-icons materialIconsHeight cp">arrow_drop_up</i>
                      <i (click)="onSortDesending(item.sortingName)"
                        class="material-icons materialIconsHeight cp">arrow_drop_down</i>
                    </div>
                  </div>
                </th>
              </tr>
            </thead>
              <tbody class="bg-white">
                <tr *ngFor="let item of updateLogsData">
                  
                    <td class="fs-12 font_regular">{{ item.fieldName }}</td>
                    <td *ngIf="item.fieldName == 'financeAccessEmployeeIds'" class="fs-12 font_regular" matTooltip="{{ item.oldValue }}" matTooltipClass="custom-tooltip"
                      style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 200px;">
                      {{ item.oldValue }}
                    </td>
                    <td *ngIf="item.fieldName != 'financeAccessEmployeeIds'"  class="fs-12 font_regular">{{ item.oldValue }}</td>
                    <td  *ngIf="item.fieldName == 'financeAccessEmployeeIds'"  class="fs-12 font_regular" matTooltip="{{ item.newValue }}" matTooltipClass="custom-tooltip"
                      style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 200px;">
                      {{ item.newValue }}
                    </td>
                    <td *ngIf="item.fieldName != 'financeAccessEmployeeIds'" class="fs-12 font_regular">{{ item.newValue }}</td>
                    <td class="fs-12 font_regular">{{ item.changedByUserName }}</td>
                    <td class="fs-12 font_regular">{{ item.createdAt | date: 'dd-MM-yyyy' }}</td>
                </tr>
              </tbody>
          </table>
    
    
        </div>
        <div class="mt-10" style="font-weight: bold;">
          {{updateLogsData.length}} entries
        </div>
      </div>


        <div class="p-10 m-20" *ngIf="selectedTypeTabName=='Deleted Reimbursement'">
          <div style="width: 30%;">
        
          </div>
        
          <div class="table-container">
        
            <table class="custom-table rounded-header">
        
              <thead>
                <tr>
        
                  <th *ngFor="let item of taskDeletedHeaderInfo " class="fs-14 font_bold cl-black">
                    <div class="p-5 verticle-center justify-content-space-between icon-style">
                      {{ item?.label }}
                      <span *ngIf="item.isMandatory" class="red-cl">&nbsp;*</span>
                      <div class="d-flex flex-column ml-10">
                        <i (click)="onSortAssending(item.sortingName)"
                          class="material-icons materialIconsHeight cp">arrow_drop_up</i>
                        <i (click)="onSortDesending(item.sortingName)"
                          class="material-icons materialIconsHeight cp">arrow_drop_down</i>
                      </div>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody class="bg-white">
                <tr *ngFor="let item of deleteLogsData">
        
                  <td class="fs-12 font_regular">{{ item.reimbursementType }}</td>
                  <td class="fs-12 font_regular">{{ item.updatedAt | date: 'dd-MM-yyyy' }}</td>
                  <td class="fs-12 font_regular">{{ item.amountLimit }}</td>
                  <td class="fs-12 font_regular">{{ item.fiscal_year }}</td>
                  <td class="fs-12 font_regular">{{ item.year }}</td>
                  <td class="fs-12 font_regular">{{ item.setLimit }}</td>
                  <td class="fs-12 font_regular">{{ item.band }}</td>
                  <td class="fs-12 font_regular">{{ item.location }}</td>
                  <td class="fs-12 font_regular">{{ formatedataVariable(item.approvedMatrix) }}</td>
        
                </tr>
              </tbody>
            </table>
        
        
          </div>
          <div class="mt-10" style="font-weight: bold;">
            {{deleteLogsData.length}} entries
          </div>
        </div>



    </div>

  </div>
  
</ion-content>